import { ReactNode, useEffect } from "react"

import { useRouteError } from "react-router"

import { captureException } from "@/lib/Tracing"

import { s } from "@/utils/i18n"

import { Button } from "@/components/Button"
import { Container } from "@/components/Container"
import ErrorBoundary from "@/components/ErrorBoundary"
import ErrorUnwrapper from "@/components/ErrorUnwrapper"
import { H5 } from "@/components/TypeRamp"
// import useHistory from "@/hooks/useHistory"
// import { Reporting } from "@/utils/reporting"

const ErrorIntrospection = () => {
  const error: any = useRouteError()

  useEffect(() => {
    console.error(error)
    captureException(error)
  }, [error])

  return error?.status === 404 ? (
    s`Error 404: Page Not Found`
  ) : (
    <>
      {s`Runtime Error:`}
      <br />
      {error?.message}
      <ErrorUnwrapper error={error} />
    </>
  )
}

export default function NotFoundPage({ error, children }: { error?: ReactNode; children?: ReactNode }) {
  // const { lastPage } = useHistory()

  return (
    <div className="flex min-h-screen items-center justify-center">
      <Container className="flex flex-col items-center text-center">
        <H5 as="h1" className="mb-5 font-mono whitespace-pre-wrap">
          {error}
          {!error && (
            <ErrorBoundary fallback="Unknown Error">
              <ErrorIntrospection />
            </ErrorBoundary>
          )}
        </H5>
        <div className="flex gap-5">
          {/* {lastPage && (
            <Button size="small" theme="secondary" href={lastPage}>
              {s`Go back`}
            </Button>
          )} */}
          <Button size="small" href="/calendar">
            {s`Go home`}
          </Button>
          {children}
        </div>
      </Container>
    </div>
  )
}
